export interface NasaPowerResponse {
  properties: {
    parameter: {
      [key: string]: {
        ANN: number;
        [month: string]: number;
      };
    };
  };
}

export async function fetchSoilTemperature(
  lat: number,
  lon: number,
  layer: string,
): Promise<{ temperature: number; error?: string }> {
  const tsoilParam = `TSOIL${parseInt(layer, 10) - 1}`;
  const url = `https://power.larc.nasa.gov/api/temporal/climatology/point?parameters=${tsoilParam}&community=AG&longitude=${lon}&latitude=${lat}&format=JSON`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      return {
        temperature: 0,
        error: `NASA POWER 请求失败 (HTTP ${response.status})`,
      };
    }

    const data: NasaPowerResponse = await response.json();
    const paramData = data.properties.parameter[tsoilParam];

    if (!paramData || typeof paramData.ANN !== 'number') {
      return {
        temperature: 0,
        error: '返回数据中未找到年均土壤温度 (ANN)',
      };
    }

    return {
      temperature: paramData.ANN,
    };
  } catch (err) {
    return {
      temperature: 0,
      error: err instanceof Error ? err.message : '网络请求异常',
    };
  }
}